<div>
    <swiper>
        <div *ngFor="let job of filteredJobResults; let index = index">
            <div>
                <jobs-search-results-job-listing [job]="job" [showShare]="false" [index]="index" [eventName]="eventName" ></jobs-search-results-job-listing>
            </div>
        </div>
    </swiper>
</div>